import { useEffect, useState } from "react";
import { Menu, MenuItem, Sidebar, SubMenu } from "react-pro-sidebar";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import SocialMedias from "../components/SocialMedias";
import useDocumentTitle from "../components/useDocumentTitle";
import { useAuth } from "../contexts/AuthContext";
import { useGetUserDataQuery } from "../features/user/userApi";
import useWindowDimensions from "../hooks/useWindowDimensions";

const Header = () => {
  const [profile, setProfile] = useState("");
  const [name, setName] = useState("");
  const { data: userData, isSuccess: getUserIsSuccess } = useGetUserDataQuery();
  useDocumentTitle(name);
  const [sideBarToggle, setSideBarToggle] = useState(false);
  useEffect(() => {
    if (getUserIsSuccess && userData?.id) {
      setProfile(userData?.profilePicture);
      setName(userData?.name);
    }
  }, [getUserIsSuccess, userData]);
  const { currentUser } = useAuth();

  return (
    <>
      <div className="mob-header">
        <div className="d-flex">
          <div className="navbar-brand">
            <Link to="/">
              <span className="logo-text">{name}</span>
            </Link>
          </div>
          <button className={`toggler-menu ${sideBarToggle ? "open" : ""}`} onClick={() => setSideBarToggle(!sideBarToggle)}>
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
      {/* End Header */}
      {/* nav bar */}
      <header className={`header-left ${sideBarToggle ? "menu-open menu-open-desk" : ""}`}>
        <div className="scroll-bar">
          <div className="hl-top">
            <div className="hl-logo">
              <div className="img">
                <img src={profile} title="" alt={name} />
              </div>
              <h5>{name}</h5>
            </div>
          </div>
          {currentUser ? <MenuWithBlog setSideBarToggle={setSideBarToggle} sideBarToggle={sideBarToggle} /> : <MenuWithOutBlog setSideBarToggle={setSideBarToggle} sideBarToggle={sideBarToggle} />}
        </div>
        <SocialMedias setSideBarToggle={setSideBarToggle} sideBarToggle={sideBarToggle} />
      </header>
    </>
  );
};
export default Header;

const MenuWithOutBlog = ({ setSideBarToggle, sideBarToggle }) => {
  let { pathname } = useLocation() || {};
  return (
    <div className="sidebar-menu">
      <ul className="nav nav-menu" id="pp-menu" onClick={() => setSideBarToggle(!sideBarToggle)}>
        <li data-menuanchor="home" className={`${pathname === "/" && "active"} header-menu`}>
          <Link className="nav-link" to="/">
            <i className="ti-home" />
            <span>Home</span>
          </Link>
        </li>
        <li data-menuanchor="about" className={`${pathname === "/about" && "active"} header-menu`}>
          <Link className="nav-link" to="/about">
            <i className="ti-id-badge" />
            <span>About Me</span>
          </Link>
        </li>
        <li data-menuanchor="services" className={`${pathname === "/services" && "active"} header-menu`}>
          <Link className="nav-link" to="/services">
            <i className="ti-panel" />
            <span>Services</span>
          </Link>
        </li>
        <li data-menuanchor="Portfolios" className={`${pathname === "/Portfolios" && "active"} header-menu`}>
          <Link className="nav-link" to="/Portfolios">
            <i className="ti-bookmark-alt" />
            <span>Portfolio</span>
          </Link>
        </li>
        {/* <li data-menuanchor="blog" className="blog header-menu">
          <Link className="nav-link" to="/blog">
            <i className="ti-layout-media-overlay-alt-2" />
            <span>Blogs</span>
          </Link>
        </li> */}
        <li data-menuanchor="contactus" className={`${pathname === "/contactus" && "active"} header-menu`}>
          <Link className="nav-link" to="/contactus">
            <i className="ti-map-alt" />
            <span>Contact Me</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

const MenuWithBlog = ({ setSideBarToggle, sideBarToggle }) => {
  const { logout } = useAuth();
  const themeNight = useSelector((state) => state.theme) || {};
  const MenuItems = (props) => <MenuItem {...props} onClick={() => setSideBarToggle(!sideBarToggle)} />;
  const { height } = useWindowDimensions();

  return (
    <div className="overflow-scroll sidebar-menu">
      <Sidebar
        rootStyles={{
          position: "-webkit-sticky",
          position: "sticky",
          top: "0",
        }}
      >
        <Menu
          rootStyles={{
            maxHeight: `${height - 250}px`,
          }}
          menuItemStyles={{
            button: ({ level, active, disabled }) => {
              // only apply styles on first level elements of the tree
              if (level === 0)
                return {
                  backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                  "&:hover": {
                    backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                  },
                  [`&.active`]: {
                    backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                    color: "#2fbf71",
                  },
                };
              if (level === 1)
                return {
                  backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                  "&:hover": {
                    backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                  },
                  [`&.active`]: {
                    backgroundColor: themeNight?.night ? "#0c0c14" : "#f7f7ff",
                    color: "#2fbf71",
                  },
                };
            },
          }}
        >
          <MenuItems icon={<i className="ti-map-alt" />} active="true" component={<Link to="/" />}>
            Home
          </MenuItems>
          <SubMenu label="User" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/userData/update" />}>
              User Data Update
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/social/media/add" />}>
              Social Media Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/social/media/List" />}>
              Social Media List
            </MenuItems>
          </SubMenu>
          <SubMenu label="About" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/about" />}>
              About Me
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/aboutMe/update" />}>
              About Me Update
            </MenuItems>
          </SubMenu>
          <SubMenu label="Services" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/services" />}>
              Services
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/service/add" />}>
              Services Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/service/list" />}>
              Services List
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/service/icon/add" />}>
              Services Icon Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/service/icon/list" />}>
              Services Icon List
            </MenuItems>
          </SubMenu>
          <SubMenu label="Portfolio" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/Portfolios" />}>
              Portfolio
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/portfolio/add" />}>
              Portfolio Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/portfolio/list" />}>
              Portfolio List
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/portfolio/tag/add" />}>
              Portfolio Tag Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/portfolio/tag/list" />}>
              Portfolio Tag List
            </MenuItems>
          </SubMenu>

          <SubMenu label="Education" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/education/add" />}>
              Education Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/education/list" />}>
              Education List
            </MenuItems>
          </SubMenu>
          <SubMenu label="Experience" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/experience/add" />}>
              Experience Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/experience/list" />}>
              Experience List
            </MenuItems>
          </SubMenu>

          <SubMenu label="Skill" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/skill/add" />}>
              Skill Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/skill/list" />}>
              Skill List
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/skill/text/update" />}>
              Skill Text
            </MenuItems>
          </SubMenu>
          <SubMenu label="Testimonial" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/testimonial/add" />}>
              Testimonial Add
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/testimonial/list" />}>
              Testimonial List
            </MenuItems>
          </SubMenu>
          <SubMenu label="Contact" icon={<i className="ti-home" />}>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/contactus" />}>
              Contact Me
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/contact/list" />}>
              Contact List
            </MenuItems>
            <MenuItems icon={<i className="ti-map-alt" />} component={<Link to="/user/contact/address/update" />}>
              Contact Address Update
            </MenuItems>
          </SubMenu>
          <span onClick={logout}>
            <MenuItems icon={<i className="ti-map-alt" />}>Logout</MenuItems>
          </span>
        </Menu>
      </Sidebar>
    </div>
  );
};
